import React, { useEffect, useState } from "react"

import { Row, Col } from "reactstrap"

// Pages Components
import Miniwidget from "./Miniwidget"
import {
  updateOrganizationRequest,
  resetOrgFlag,
} from "../../store/Organization/actions"
import MonthlyEarnings from "./montly-earnings"
import EmailSent from "./email-sent"
import MonthlyEarnings2 from "./montly-earnings2"
import MonthlyEarnings3 from "./monthly-earnings3"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import { useSelector, useDispatch, connect } from "react-redux"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"
import { useNavigate } from "react-router-dom"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
import config from "config/config"
import axios from "axios"
import SnackbarComponent from "components/SnackBar"

const Dashboard = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [chartData, setChartData] = useState(null)
  const [chartCityData, setChartCityData] = useState(null)
  const [charteventData, setChartEventData] = useState(null)
  const [success, setSuccess] = useState(null)
  const [deviceData, setDeviceData] = useState(null)
  const userData = useSelector(state => state.Login.userData)
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const [analyticsData, setAnalyticsData] = useState(null)
  const [reports, setReports] = useState(null)
  const [err, setErr] = useState(null)

  console.log("active: ", activeOrganization)
  document.title = "Dashboard | AeraVue"

  const breadcrumbItems = [
    {
      title: `${activeOrganization?.name}`,
      link: "#",
    },
    { title: "Dashboard", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems(
      `${activeOrganization?.name} (${activeOrganization?.type})`,
      breadcrumbItems,
    )

    setAnalyticsData(activeOrganization.GoogleAnalyticsIntegrations[0])
  }, [])

  const refreshToken = async () => {
    try {
      const response = await axios.put(
        `${config.backendUrl}/analytics/refreshToken?refreshToken=${analyticsData.refreshToken}&orgId=${activeOrganization.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      dispatch(
        updateOrganizationRequest({
          organizationId: activeOrganization.id,
          ...activeOrganization,
        }),
      )
    } catch (err) {
      if (err.status === 400) {
        setErr("Token has expired. Please login again.")
        dispatch(
          updateOrganizationRequest({
            organizationId: activeOrganization.id,
            ...activeOrganization,
          }),
        )
        setTimeout(() => {
          navigate("/integrations")
        }, 2000)
      }
    }
  }
  useEffect(() => {
    if (analyticsData) {
      console.log("Analytics data", analyticsData)
      const parsedDate = new Date(analyticsData.tokenExpiry)
      console.log("expiry :", analyticsData.tokenExpiry)

      // Get the current time
      const now = new Date()

      console.log("a", parsedDate)
      console.log("b", now)

      // Check if the date has passed
      if (parsedDate < now) {
        refreshToken()
        // console.log("Date has passed.")
      } else {
        console.log("The date and time has not passed yet.")
      }
    }
  }, [analyticsData])

  const fetchReports = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/analytics/getReport?accessToken=${analyticsData.accessToken}&propertyId=${analyticsData.propertyId}&accountId=${analyticsData.accountId}`,
      )
      const data = response.data
      // Use a map to group active users by country
      const countryData = {}
      const cityData = {}
      const eventNameData = {}
      const deviceCategoryData = {}
      const totalUsers = data.rows.reduce(
        (sum, row) => sum + Number(row.metricValues[0]?.value || 0),
        0,
      )
      const totalSessions = data.rows.reduce(
        (sum, row) => sum + Number(row.metricValues[1]?.value || 0),
        0,
      )
      const topDevice = data.rows[0]?.dimensionValues[3]?.value || "Unknown"
      const topEvent = data.rows[0]?.dimensionValues[2]?.value || "Unknown"

      setReports([
        {
          title: "Total Active Users",
          iconClass: "cube-outline",
          total: totalUsers,
          average: "",
          badgecolor: "success",
        },
        {
          title: "Total Sessions",
          iconClass: "buffer",
          total: totalSessions,
          average: "",
          badgecolor: "info",
        },
        {
          title: "Top Device",
          iconClass: "tag-text-outline",
          total: topDevice,
          average: "",
          badgecolor: "primary",
        },
        {
          title: "Top Event",
          iconClass: "briefcase-check",
          total: topEvent,
          average: "",
          badgecolor: "warning",
        },
      ])
      data.rows.forEach(row => {
        const country = row.dimensionValues[0].value
        const city = row.dimensionValues[1].value
        const activeUsers = Number(row.metricValues[0].value)
        const activeCityUsers = Number(row.metricValues[1].value)
        const eventName = row.dimensionValues[2].value
        const deviceCategory = row.dimensionValues[3].value
        const activeEventName = Number(row.metricValues[2].value)
        const activeDeviceCategory = Number(1)

        if (countryData[country]) {
          countryData[country] += activeUsers // Add up the users if country already exists
        } else {
          countryData[country] = activeUsers // Initialize the country
        }
        if (cityData[city]) {
          cityData[city] += activeCityUsers // Add up the users if country already exists
        } else {
          cityData[city] = activeCityUsers // Initialize the country
        }
        if (eventNameData[eventName]) {
          eventNameData[eventName] += activeEventName // Add up the users if country already exists
        } else {
          eventNameData[eventName] = activeEventName // Initialize the country
        }
        if (deviceCategoryData[deviceCategory]) {
          deviceCategoryData[deviceCategory] += activeDeviceCategory // Add up the users if country already exists
        } else {
          deviceCategoryData[deviceCategory] = activeDeviceCategory // Initialize the country
        }
      })

      // Extract unique countries and active users for the chart
      const countries = Object.keys(countryData)
      const activeUsers = Object.values(countryData)

      // Extract unique cities and active users for the chart
      const cities = Object.keys(cityData)
      const activeCityUsers = Object.values(cityData)

      // Extract unique cities and active users for the chart
      const events = Object.keys(eventNameData)
      const activeEvents = Object.values(eventNameData)

      // Extract unique cities and active users for the chart
      const device = Object.keys(deviceCategoryData)
      const activeDevice = Object.values(deviceCategoryData)

      setChartData({
        labels: countries,
        datasets: [
          {
            label: "Active Users",
            data: activeUsers,
            backgroundColor: "rgba(75, 192, 192, 0.6)",
          },
        ],
      })
      setChartCityData({
        labels: cities,
        datasets: [
          {
            label: "Active Users By City",
            data: activeCityUsers,
            backgroundColor: "rgba(75, 192, 192, 0.6)",
          },
        ],
      })
      setChartEventData({
        labels: events,
        datasets: [
          {
            label: "Active Events",
            data: activeEvents,
            backgroundColor: "rgba(75, 192, 192, 0.6)",
          },
        ],
      })
      setDeviceData({
        labels: device,
        datasets: [
          {
            label: "Active Device",
            data: activeDevice,
            backgroundColor: "rgba(75, 192, 192, 0.6)",
          },
        ],
      })
    } catch (error) {
      console.error("Error fetching view IDs", error)
    }
  }

  useEffect(() => {
    if (analyticsData) {
      fetchReports()
    }
  }, [activeOrganization])

  return (
    <React.Fragment>
      {/*mimi widgets */}
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <Miniwidget reports={reports} />

      <Row>
        <Col xl="6">
          {/* Monthly Earnings */}
          <MonthlyEarnings />
        </Col>

        <Col xl="6">
          <MonthlyEarnings3 />
        </Col>

        {/* <Col xl="6">
          <MonthlyEarnings2 />
        </Col> */}
      </Row>
      <Row>
        <Col xl="12">
          <EmailSent />
        </Col>
      </Row>
      {/* <Row>
        <Col xl="12">
          <EmailSent />
        </Col>
      </Row> */}
      {/* <Row>
        <Col xl="4" lg="6">
          <Inbox />
        </Col>
        <Col xl="4" lg="6">
          <RecentActivity />
        </Col>
        <Col xl="4">
          <WidgetUser />

          <YearlySales />
        </Col>
      </Row>

      <Row>
        <Col xl="6">
          <LatestTransactions />
        </Col>

        <Col xl="6">
          <LatestOrders />
        </Col>
      </Row> */}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard)
